import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import "./index.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("root element ontbreekt");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
